import { Calendar, Download, Menu } from "lucide-react";
import './analyticheader.css'
const AnalyticsHeader = ({ onMenuClick }) => {
  return (
    <div className="rp-analytics-header">
      
      {/* Left Section */}
      <div className="rp-analytics-header-left">
        <Menu 
          className="menu-btn " 
          onClick={onMenuClick}
        />

        <div className="rp-analytics-title-wrap">
          <h1 className="rp-analytics-title">
            Perpormance Insights
          </h1>
          <p className="rp-analytics-subtitle">
            Track your referral perpormance and earnings
          </p>
        </div>
      </div>

      {/* Right Section */}
      <div className="rp-analytics-btn-group">
      <button className="rp-analytics-btn">
        <Calendar size={16} className="rp-analytics-btn-icon" />
        Date Range
      </button>

      <button className="rp-analytics-btn">
        <Download size={16} className="rp-analytics-btn-icon" />
        Export
      </button>
    </div>
    </div>
  );
};

export default AnalyticsHeader;
